export const invoice_template = () =>
  `https://ai-demo.sthambh.com/invoice-template`;

export const parse_invoice = () => `https://ai-demo.sthambh.com/upload/`;

export const uploadCSV = () => `https://ai-demo.sthambh.com/upload-csv/`;

export const ask_question = () => `https://ai-demo.sthambh.com/ask-question/`;
